import { render, staticRenderFns } from "./ReceptionStatusForm.vue?vue&type=template&id=059a0d11&scoped=true&"
import script from "./ReceptionStatusForm.vue?vue&type=script&lang=js&"
export * from "./ReceptionStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a0d11",
  null
  
)

export default component.exports